import React from 'react';
import styled from 'styled-components';

const FormCardWrapper = styled.div`
  width: ${({ width }) => width || '250px'};
  border: 1px solid silver;
  border-radius: 15px;
  margin-top: 50px;
  padding: 20px;
`;

export function FormCard(props) {
  return <FormCardWrapper {...props} />;
}
